module.exports = __webpack_public_path__ + "static/img/信息化4.86ead4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/index/dss/信息化4.png
// module id = Vkr7
// module chunks = 0 2